export default "__VITE_ASSET__9e7bbce8__"